@if (displayValue !== undefined) {
  <div [tooltip]="true" [tooltipInvertTextColor]="true">
    {{ displayValue | date: dateFormat }}
  </div>
} @else if (!hideEmpty) {
  <span class="text-slate-300">-</span>
}
